import BaseContainer from './BaseContainer';
export default class Rect extends BaseContainer{
    /**
     * 
     * @param {Object} options 
     * @param {Number} options.width 
     * @param {Number} options.height 
     * @param {Number} options.lineColor 
     * @param {Number} options.lineWidth 
     * @param {Number} options.lineAlpha
     * @param {Number} options.fillColor 
     * @param {Number} options.fillAlpha
     * @param {Number} options.cornerRadius  - 圆角半径
     * @param {Number} options.shadowColor  - 阴影颜色
     * @param {Number} options.shadowAlpha  - 阴影透明度
     * @param {Number} options.shadowX --阴影X
     * @param {Number} options.shadowY --阴影y
     */
    constructor(options){
        super();

        this.grapics = new PIXI.Graphics();
        this.addChild(this.grapics);

        options = options || {};
        this._initOptions(options, "width", 5);
        this._initOptions(options, "height", 5);
        this._initOptions(options, "lineColor", null);
        this._initOptions(options, "lineWidth", 1);
        this._initOptions(options, "lineAlpha", 1);
        this._initOptions(options, "fillColor", null);
        this._initOptions(options, "fillAlpha", 1);
        this._initOptions(options, "cornerRadius", 0);
        this._initOptions(options, "shadowColor", null);
        this._initOptions(options, "shadowAlpha", 1);
        this._initOptions(options, "shadowX", 0);
        this._initOptions(options, "shadowY", 0);
    }

    _initOptions(options, key, init){
        this[key] = (options[key] !== undefined) ? options[key] : init;
    }

    _onSizeChanged(){
        super._onSizeChanged();
        this.dirty();
    }

    redraw(){
        this.grapics.clear();
        if(this.shadowAlpha > 0 && this.shadowColor !== null){
            this.grapics.beginFill(this.shadowColor, this.shadowAlpha);
            this._drawRect(this.shadowX, this.shadowY);
            this.grapics.endFill();            
        }
        if(this.fillAlpha > 0 && this.fillColor !== null){
            this.grapics.beginFill(this.fillColor, this.fillAlpha);
            this._drawRect();
            this.grapics.endFill();
        }
        if(this.lineAlpha > 0 && this.lineColor !== null){
            this.grapics.lineStyle(this.lineWidth, this.lineColor, this.lineAlpha, 0.5);
            this._drawRect();
        }
    }

    resize(w, h) {
        this.width = w;
        this.height = h;
        this.dirty();
    }

    _drawRect(x, y){
        x = x || 0;
        y = y || 0;
        if(this.cornerRadius != 0){
            this.grapics.drawRoundedRect(x, y, this.width, this.height, this.cornerRadius);
        } else {
            this.grapics.drawRect(x, y, this.width, this.height);
        }
    }
}


// WEBPACK FOOTER //
// ./src/common/scripts/pixi/component/Rect.js